import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  wrapper: {
    ...theme.mixins.appContainer,
    marginTop: theme.spacing(1),
  },
  content: {
    '& > div + div': {
      marginTop: theme.spacing(3),
    },
  },
  buttonWrapper: {
    padding: '16px 0',
  },
  themeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}));
